export var MarketingConsentDetailsIdentifierType;
(function (MarketingConsentDetailsIdentifierType) {
    MarketingConsentDetailsIdentifierType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    MarketingConsentDetailsIdentifierType["EMAIL"] = "EMAIL";
    MarketingConsentDetailsIdentifierType["PHONE"] = "PHONE";
})(MarketingConsentDetailsIdentifierType || (MarketingConsentDetailsIdentifierType = {}));
export var MarketingConsentState;
(function (MarketingConsentState) {
    MarketingConsentState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    MarketingConsentState["NEVER_CONFIRMED"] = "NEVER_CONFIRMED";
    MarketingConsentState["REVOKED"] = "REVOKED";
    MarketingConsentState["PENDING"] = "PENDING";
    MarketingConsentState["CONFIRMED"] = "CONFIRMED";
})(MarketingConsentState || (MarketingConsentState = {}));
export var Source;
(function (Source) {
    Source["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
    Source["IN_PERSON"] = "IN_PERSON";
    Source["FORM"] = "FORM";
    Source["LINK_CONFIRMATION"] = "LINK_CONFIRMATION";
    Source["EMAIL_SERVICE"] = "EMAIL_SERVICE";
    Source["WIX_USERS"] = "WIX_USERS";
    Source["OTHER"] = "OTHER";
})(Source || (Source = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["UNKNOWN_OPT_IN_LEVEL"] = "UNKNOWN_OPT_IN_LEVEL";
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var LastRevokeActivitySource;
(function (LastRevokeActivitySource) {
    LastRevokeActivitySource["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
    LastRevokeActivitySource["IN_PERSON"] = "IN_PERSON";
    LastRevokeActivitySource["FORM"] = "FORM";
    LastRevokeActivitySource["REVOKE_LINK"] = "REVOKE_LINK";
    LastRevokeActivitySource["OTHER"] = "OTHER";
})(LastRevokeActivitySource || (LastRevokeActivitySource = {}));
export var LinkType;
(function (LinkType) {
    LinkType["UNKNOWN_LINK_TYPE"] = "UNKNOWN_LINK_TYPE";
    LinkType["CONFIRMATION"] = "CONFIRMATION";
    LinkType["REVOKE_CONFIRMATION"] = "REVOKE_CONFIRMATION";
})(LinkType || (LinkType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map